import { render, staticRenderFns } from "./fundingDetails.vue?vue&type=template&id=709d4af2&scoped=true"
import script from "./fundingDetails.vue?vue&type=script&lang=js"
export * from "./fundingDetails.vue?vue&type=script&lang=js"
import style0 from "./fundingDetails.vue?vue&type=style&index=0&id=709d4af2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709d4af2",
  null
  
)

export default component.exports